import { Swiper } from 'swiper';
import { Autoplay, Navigation } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', () => {
  const swiperElement = document.querySelector<HTMLElement>(
    '[data-top-area-swiper]'
  );

  if (!swiperElement) return;

  const areaSwiper = new Swiper(swiperElement, {
    modules: [Autoplay, Navigation],
    navigation: {
      nextEl: '[data-top-area-swiper-next]',
      prevEl: '[data-top-area-swiper-prev]',
    },
    slidesPerView: 1,
    spaceBetween: 16,
    loop: true,
    speed: 3000,
  });

  // SVGマップのクリックイベント
  const areaLinks = document.querySelectorAll<SVGGElement>('svg [data-area-id]');

  areaLinks.forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();

      const areaId = link.dataset.areaId;
      if (!areaId) return;

      // 全てのaタグから.activeを削除し、クリックされたaタグに.activeを追加
      areaLinks.forEach((el) => el.classList.remove('active'));
      link.classList.add('active');

      // 対応するスライドのインデックスを取得
      const slides = swiperElement.querySelectorAll('.swiper-slide');
      let targetIndex = -1;

      slides.forEach((slide, index) => {
        if (slide.getAttribute('data-area-id') === areaId) {
          targetIndex = index;
        }
      });

      if (targetIndex !== -1) {
        areaSwiper.slideToLoop(targetIndex);
      }
    });
  });

  // Swiperのアクティブなスライドに対応するマップエリアをアクティブにする
  const updateActiveMapFromSwiper = (): void => {
    const activeSlide = areaSwiper.slides[areaSwiper.activeIndex];
    const activeAreaId = activeSlide?.getAttribute('data-area-id');

    areaLinks.forEach((link) => {
      if (link.dataset.areaId === activeAreaId) {
        link.classList.add('active');
      } else {
        link.classList.remove('active');
      }
    });
  };

  // スライド変更時にマップを更新
  areaSwiper.on('slideChange', updateActiveMapFromSwiper);

  // 初回ロード時にアクティブ状態を設定
  updateActiveMapFromSwiper();
});
